import create from 'zustand';

// Zustand store for managing the active menu
export const useMenuStore = create((set) => ({
    activeMenuId: 2, // Default to "Home"
    setActiveMenuId: (id) => set({ activeMenuId: id }),
}));
